import { useState } from "react";
import { searchStorageAsync } from "../../../../BaseInfo/store/api/StorageApi";
import SearchableSelect from "../../../../Components/SearchableSelect";

const StorageSearch = ({ onStorageChange }) => {

    const [selectedStorage, setSelectedStorage] = useState({});
    const handleSelect = (opt) => {
        const data = { StorageID: opt.value, StorageName: opt.label };
        onStorageChange({ ...data });
        setSelectedStorage({ ...data });
    }
    const handleNameSearch = async (data) => {
        data = String(data).trim();
        if (!data?.length > 0) {
            onStorageChange({});
            setSelectedStorage({});
            return [];
        }
        const result = await searchStorageAsync(data, 10, "");
        if (Array.isArray(result?.Data) && result.Data.length > 0) {
            return result.Data.map(r => ({
                value: r.StorageID,
                label: r.StorageName
            }));
        }
        return [];
    }
    return (
        <div className="storage-search-div">
            <SearchableSelect
                className="search-storage-input"
                value={selectedStorage.StorageID ?? ""}
                defaultLabel={selectedStorage.StorageName ?? ""}
                placeholder="جستجوی انبار..."
                loadOptions={handleNameSearch}
                onChange={handleSelect}
            />
        </div>
    )
}
export default StorageSearch;